import { Box, Grid, Stack, StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AgendaCardWrapper = styled(Box)(({ theme }) => ({
  margin: "33px auto 0",
  overflow: "hidden",
  border: `2px solid ${theme.customColors.border}`,
  borderRadius: "0.5rem",
  padding: "32px 24px",
  width: "min-content",
  [theme.breakpoints.down("md")]: {
    width: "100%"
  }
}));

export const AgendaCalendarRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "stretch",
  gap: "32px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column"
  }
}));

export const AgendaVerticalDivider = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.customColors.border}`,
  alignSelf: "stretch",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    height: 0
  }
}));

export const AgendaCalendarPanel = styled(Box)(() => ({
  flex: "0 0 auto"
}));

export const AgendaEventsPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: "580px",
  [theme.breakpoints.down("sm")]: {
    minWidth: 0
  }
}));

export const CalendarBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  overflow: "hidden",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    justifyContent: "center"
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "start",
    paddingBottom: "0",
    paddingTop: "32px"
  }
}));

export const AgendaStack = styled(Stack)<StackProps & { src?: string }>(({ src, theme }) => ({
  // eslint-disable-next-line max-len
  background: src ? `${theme.linearGradients.gradientC}, url(${src})` : "transparent",
  backgroundPositionX: "center",
  backgroundPositionY: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  flexGrow: 1,
  maxWidth: "100%"
}));
